// extracted by mini-css-extract-plugin
export default {"container":"InspectionResult_container__uKdbW","inspectionResultSwitch":"InspectionResult_inspectionResultSwitch__+mJqu","loading":"InspectionResult_loading__Y5jIA"};